import axios from 'axios';
import { getConfig } from '../../../config/apiConfig';
import authService from '../../../authentication/AuthorizeService';
import getLogger from '../../../utils/logger';

const getNotificationCount = async (userId, refresh, countOverDue) => {
  let targetUserId = userId;
  let forceRefresh = refresh;
  let countOverDueOnly = countOverDue;

  if (!targetUserId) {
    targetUserId = await authService.getMaskedUserId();
  }
  if (!refresh) {
    forceRefresh = false;
  }
  if (!countOverDue) {
    countOverDueOnly = false;
  }
  // Get auth header config
  const config = await getConfig();
  const requestUrl = `api/timelineapi/LoadNotificationCount?targetUserId=${targetUserId}&forceRefresh=${forceRefresh}&countOverDueOnly=${countOverDueOnly}`;
  return axios
    .get(requestUrl, config)
    .then(async (response) => {
      return response.data;
    })
    .catch((err) => {
      getLogger().error(err.response);
      return 0;
    });
};

export default getNotificationCount;
